<template>
  <div class="container filter-musics-component mt-5">
    <div class="bg-grey px-lg-4 position-relative">
      <div class="d-flex py-3 align-items-center">
        <button @click="showFilters = !showFilters">
          <img
            src="@/assets/images/repertories/filter_list.svg"
            alt="filter-list"
            class="mr-lg-3"
          />
        </button>
        <p class="my-0 text-grey">
          Pesquisar
        </p>
      </div>
      <div class="position-absolute box-filter" v-if="showFilters">
        <form-group
          id="filter"
          v-model="filter"
          type="text"
          placeholder="Pesquisar"
        />
        <drop-down-filters
          :items="themes"
          @getRepertoriesByFilters="updateMusicsArray"
        />
        <drop-down-filters @getRepertoriesByFilters="updateMusicsArray" />
      </div>
    </div>
    <div class="justify-content-between mt-2 d-none d-lg-flex">
      <button
        class="btn-alphabet text-white"
        v-for="(letter, i) in this.alphabet"
        :key="i"
        @click="updateMusicsArrayByLetter(letter)"
        :class="{ 'btn-green': checkSelected(letter) }"
      >
        {{ letter }}
      </button>
    </div>
    <div
      class="d-flex justify-content-between align-items-center pb-3 pt-4 border-bottom"
    >
      <p class="mb-n3">[{{ formatNumber(musicsLength) }}] Repertório total.</p>

      <div class="d-flex align-items-center">
        <p class="mb-n3 mr-2 d-none d-lg-block">Ordenar por</p>
        <div class="form-group mb-n3">
          <custom-select :options="options" @filter="filterDropdown" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormGroup from "../FormGroup.vue";
import DropDownFilters from "./DropDownFilters.vue";
import { alphabet } from "@/functions/helpers.js";
import CustomSelect from "./CustomSelect.vue";
export default {
  components: {
    FormGroup,
    DropDownFilters,
    CustomSelect
  },

  data() {
    return {
      showFilters: "",
      filter: "",
      alphabet: alphabet,
      selectedLetters: [],
      item: [{ name: "ordem alfabética" }],
      options: [
        { value: "alpha", text: "Ordem Alfabética" },
        { value: "desc", text: "Mais Recentes" },
        { value: "inten", text: "Intensidade" }
      ]
    };
  },
  props: {
    themes: {
      typeof: Array,
      default: () => []
    },
    musicsLength: {
      typeof: Number,
      default: null
    }
  },
  methods: {
    filterDropdown(i) {
      let payload = { order_by: i.value };
      this.$emit("updateMusicsByFilter", payload);
    },
    updateMusicsArray(payload) {
      this.$emit("updateMusicsByFilter", payload);
    },
    updateMusicsArrayByLetter(letter) {
      if (
        letter == "#" ||
        this.selectedLetters.length > this.alphabet.length - 1
      ) {
        this.selectedLetters = [];
      } else if (this.selectedLetters.includes(letter)) {
        const index = this.selectedLetters.indexOf(letter);
        this.selectedLetters.splice(index, 1);
      } else {
        this.selectedLetters.push(letter);
      }
      this.$emit("updateMusicsByFilter", {
        letters: this.selectedLetters
      });
    },
    checkSelected(letter) {
      return this.selectedLetters.includes(letter) ? true : false;
    },
    formatNumber(number) {
      if (number == 0) {
        return "0";
      }
      if (number < 10) {
        return "0" + number;
      }
      return number;
    }
  },
  watch: {
    filter(newValue) {
      this.$emit("filterByText", { text: newValue });
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-musics-component {
  .box-filter {
    width: 400px;
    z-index: 10px;
    background-color: #111112;
    top: 0.8rem;
    left: 5rem;
    @media screen and (max-width: 992px) {
      left: 0;
      width: 85%;
      left: 3rem;
    }
  }
  .bg-grey {
    background-color: #111112;
    border-radius: 6px;
  }
  .text-grey {
    color: #8b8b8b;
  }
  select {
    border: 1px solid #8b8b8b;

    &:focus {
      box-shadow: 0 0 0 0;
      outline: 0;
    }
  }

  button {
    background-color: transparent;
    border: none;
  }

  .btn-outline-success {
    border: 1px solid green;
  }

  .btn-alphabet {
    border-radius: 8px;
    width: 30px !important;
    height: 35px !important;
    transition: 0.4s;
    &:hover {
      background-color: #111112;
      border: none;
    }
  }

  .btn-green {
    background-color: rgba($color: #2db563, $alpha: 0.25);
    border: none;
  }

  .border-bottom {
    border-bottom: 2px solid #111112 !important;
  }
}
</style>
